/** 将法律文案中的 {{var}} 替换为运行时值（词条仍保留在 JSON 中） */
export function fillLegalTemplate(template: string, vars: Record<string, string>) {
  return template.replace(/\{\{(\w+)\}\}/g, (_, key: string) => vars[key] ?? '')
}
